var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$route.name !== '404')?_c('Header'):_vm._e(),_c('transition',{attrs:{"mode":"out-in"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }